













import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class UploadProgress extends Vue {
  @Prop({ type: Number, default: 0 }) readonly value!: number;
  @Prop({ type: String }) readonly fileName!: string;
  @Prop({ type: Boolean, default: false }) readonly indeterminate!: Boolean;
  @Prop({ type: Boolean, default: false }) readonly show!: Boolean;

  @Emit('delete')
  onDelete () {
    // do nothing
  }
}
